import { GENERATED_REPORT_FRAGMENT } from './fragments'

const { gql } = require('graphql-request')

export const GET_GENERATED_REPORTS = gql`
  query GetGeneratedReports($first: Int, $after: String, $filters: GeneratedReportFilters, $sortBy: GeneratedReportSort) {
    generatedReports(first: $first, after: $after, filters: $filters, sortBy: $sortBy) {
      edges {
        node {
          ...generatedReportInfo
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
  ${GENERATED_REPORT_FRAGMENT}
`

export const GET_GENERATED_REPORT = gql`
  query GetGeneratedReport($id: ID!) {
    generatedReport(id: $id) {
      ...generatedReportInfo
    }
  }
  ${GENERATED_REPORT_FRAGMENT}
`

const queries = {
  GET_GENERATED_REPORTS,
  GET_GENERATED_REPORT
}

export default queries 